import React, { useState } from "react";
import { useRegistry } from "../hooks/useRegistry";
import RegistryItemCard from "./RegistryItemCard";
import LoadingSpinner from "./LoadingSpinner";
import PurchasePopup from "./PurchasePopup";

interface RegistryPageProps {
  invitation: any;
}

const RegistryPage: React.FC<RegistryPageProps> = ({ invitation }) => {
  const { items, loading, error, markAsPurchased } = useRegistry();
  const [purchasePopup, setPurchasePopup] = useState<{
    isOpen: boolean;
    itemId: string;
    itemName: string;
  }>({
    isOpen: false,
    itemId: "",
    itemName: "",
  });

  const handleMarkAsPurchased = (itemId: string) => {
    const item = items.find((i) => i.id === itemId);
    if (item) {
      setPurchasePopup({
        isOpen: true,
        itemId,
        itemName: item.name,
      });
    }
  };

  const handlePurchaseConfirm = async (
    purchasedByName: string,
    purchasedById?: string,
    note?: string
  ) => {
    try {
      await markAsPurchased(
        purchasePopup.itemId,
        purchasedByName,
        purchasedById,
        note
      );
      setPurchasePopup({ isOpen: false, itemId: "", itemName: "" });
    } catch (err) {
      console.error("Failed to mark item as purchased:", err);
    }
  };

  const handlePurchaseCancel = () => {
    setPurchasePopup({ isOpen: false, itemId: "", itemName: "" });
  };

  if (loading) return <LoadingSpinner message="Loading registry items..." />;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="registry-page">
      <div className="registry-grid">
        {items.map((item) => (
          <RegistryItemCard
            key={item.id}
            item={item}
            onMarkAsPurchased={handleMarkAsPurchased}
            purchasedBy={item.purchased_by_name}
          />
        ))}
      </div>

      <PurchasePopup
        isOpen={purchasePopup.isOpen}
        itemName={purchasePopup.itemName}
        onConfirm={handlePurchaseConfirm}
        onCancel={handlePurchaseCancel}
        defaultPurchasedBy={invitation?.guest_names || ""}
      />
    </div>
  );
};

export default RegistryPage;
